import React, { useState, useEffect } from "react";
import { useOrganisations } from "../Auth/useOrganisations";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Swal from "sweetalert2";
import moment from "moment";
import {
  getFournisseurs,
  getHistoriqueFournisseurs,
  getSupplierPayments,
  getSupplierPurchases,
  getSupplierStats,
} from "../Services/AchatApi";
import { formatDate, formatdate, formatDateAndTime } from "../Helpers/Helpers";
import AddFournisseurModal from "../Components/FournisseurForm";

const FournisseurList = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, , usedOrganisations] = useOrganisations();
  const [activeTab, setActiveTab] = useState("purchases");

  const [showAddModal, setShowAddModal] = useState(false);
  const formatCurrency = (amount) => {
    return parseFloat(amount || 0).toFixed(3) + " TND";
  };
  // Modal states
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierPurchases, setSupplierPurchases] = useState([]);
  const [supplierPayments, setSupplierPayments] = useState([]);
  const [supplierStats, setSupplierStats] = useState(null);
  const [showHistoriqueModal, setShowHistoriqueModal] = useState(false);
  const [historiqueSupplier, setHistoriqueSupplier] = useState(null);
  const [historiqueEvents, setHistoriqueEvents] = useState([]);
  const [historiqueLoading, setHistoriqueLoading] = useState(false);
  const handleSoldeClick = async (supplier) => {
    setHistoriqueSupplier(supplier);
    setShowHistoriqueModal(true);
    setHistoriqueLoading(true);
    try {
      const response = await getHistoriqueFournisseurs(supplier.id);
      if (response.data.success) {
        setHistoriqueEvents(response.data.data.events || []);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement de l'historique");
    } finally {
      setHistoriqueLoading(false);
    }
  };
  // Filters
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [editingFournisseur, setEditingFournisseur] = useState(null);
  useEffect(() => {
    if (usedOrganisations) {
      loadSuppliers();
    }
  }, [usedOrganisations]);
  const handleViewDetails = async (supplier) => {
    setSelectedSupplier(supplier);

    try {
      // Load supplier purchases
      const purchasesResponse = await getSupplierPurchases(
        supplier.id,
        usedOrganisations,
      );
      if (purchasesResponse.data.success) {
        setSupplierPurchases(purchasesResponse.data.data || []);
      }

      // Load supplier payments
      const paymentsResponse = await getSupplierPayments(
        supplier.id,
        usedOrganisations,
      );
      if (paymentsResponse.data.success) {
        setSupplierPayments(paymentsResponse.data.data || []);
      }

      // Load supplier stats
      const statsResponse = await getSupplierStats(
        supplier.id,
        usedOrganisations,
      );
      if (statsResponse.data.success) {
        setSupplierStats(statsResponse.data.data);
      }

      setShowDetailsModal(true);
    } catch (error) {
      toast.error("Erreur lors du chargement des détails");
    }
  };
  const loadSuppliers = async () => {
    try {
      setLoading(true);
      const response = await getFournisseurs(usedOrganisations, searchTerm);
      if (response.data.success) {
        setSuppliers(response.data.data || []);
        console.log(response);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des fournisseurs");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    loadSuppliers();
  };

  const getStatusBadge = (statut) => {
    const statusMap = {
      actif: "success",
      inactif: "secondary",
      bloqué: "danger",
    };
    return (
      <span className={`badge badge-${statusMap[statut] || "secondary"}`}>
        {statut}
      </span>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="box-title">Gestion des Fournisseurs</h4>
                <button
                  className="btn btn-danger"
                  onClick={() => setShowAddModal(true)}
                >
                  <i className="fa fa-plus mr-2"></i>
                  Nouveau Fournisseur
                </button>
              </div>

              {/* Filters */}
              <div className="card mb-4">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="form-group">
                        <label>Recherche</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nom, email, téléphone, MF..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyPress={(e) =>
                              e.key === "Enter" && handleSearch()
                            }
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-primary"
                              onClick={handleSearch}
                            >
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Statut</label>
                        <select
                          className="form-control"
                          value={filterStatus}
                          onChange={(e) => setFilterStatus(e.target.value)}
                        >
                          <option value="">Tous</option>
                          <option value="actif">Actif</option>
                          <option value="inactif">Inactif</option>
                          <option value="bloqué">Bloqué</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4 d-flex">
                      <button
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                          setSearchTerm("");
                          setFilterStatus("");
                          loadSuppliers();
                        }}
                      >
                        <i className="fas fa-undo"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Suppliers Table */}
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Chargement...</span>
                  </div>
                  <p className="mt-2">Chargement des fournisseurs...</p>
                </div>
              ) : suppliers.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fa fa-truck fa-4x text-muted mb-3"></i>
                  <h5>Aucun fournisseur trouvé</h5>
                  <p className="text-muted">
                    Commencez par ajouter votre premier fournisseur.
                  </p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>Code</th>
                        <th>Nom</th>
                        <th>Matricule Fiscal</th>
                        <th>Téléphone</th>
                        <th>Email</th>
                        <th>Solde Actuel</th>
                        <th>Statut</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {suppliers.map((supplier) => (
                        <tr key={supplier.id}>
                          <td>
                            <span className="badge badge-info">
                              {supplier.code}
                            </span>
                          </td>
                          <td>
                            <strong>{supplier.nom}</strong>
                          </td>
                          <td>{supplier.matricule_fiscal || "-"}</td>
                          <td>{supplier.telephone}</td>
                          <td>{supplier.email || "-"}</td>
                          <td
                            className={`${supplier.solde_actuel > 0 ? "text-danger font-weight-bold" : "text-success"}`}
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline dotted",
                            }}
                            title="Voir historique"
                            onClick={() => handleSoldeClick(supplier)}
                          >
                            {formatCurrency(supplier.solde_actuel || 0)}
                          </td>
                          <td>{getStatusBadge(supplier.statut)}</td>
                          <td>
                            <div className="btn-group" style={{ gap: "5px" }}>
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => handleViewDetails(supplier)}
                                title="Voir détails"
                              >
                                <i className="fa fa-eye"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() => {
                                  setEditingFournisseur(supplier.id);
                                  setShowAddModal(true);
                                }}
                                title="Modifier"
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Supplier Details Modal */}
      {showDetailsModal && selectedSupplier && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Détails du Fournisseur - {selectedSupplier.nom}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowDetailsModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* Supplier Info Card */}
                <div className="card bg-light mb-4">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <p>
                          <strong>Code:</strong> {selectedSupplier.code}
                        </p>
                        <p>
                          <strong>Nom:</strong> {selectedSupplier.nom}
                        </p>
                        <p>
                          <strong>Contact:</strong>{" "}
                          {selectedSupplier.contact || "-"}
                        </p>
                      </div>
                      <div className="col-md-3">
                        <p>
                          <strong>MF:</strong>{" "}
                          {selectedSupplier.matricule_fiscal || "-"}
                        </p>
                        <p>
                          <strong>RC:</strong>{" "}
                          {selectedSupplier.registre_commerce || "-"}
                        </p>
                        <p>
                          <strong>TVA:</strong>{" "}
                          {selectedSupplier.numero_tva || "-"}
                        </p>
                      </div>
                      <div className="col-md-3">
                        <p>
                          <strong>Tél:</strong> {selectedSupplier.telephone}
                        </p>
                        <p>
                          <strong>Email:</strong>{" "}
                          {selectedSupplier.email || "-"}
                        </p>
                        <p>
                          <strong>Adresse:</strong>{" "}
                          {selectedSupplier.adresse || "-"}
                        </p>
                      </div>
                      <div className="col-md-3">
                        <p>
                          <strong>Conditions:</strong>{" "}
                          {selectedSupplier.conditions_paiement}
                        </p>
                        <p>
                          <strong>Délai:</strong>{" "}
                          {selectedSupplier.delai_paiement} jours
                        </p>
                        <p>
                          <strong>Statut:</strong>{" "}
                          {getStatusBadge(selectedSupplier.statut)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stats Cards */}
                {supplierStats && (
                  <div className="row mb-4">
                    <div className="col-md-3">
                      <div className="card bg-primary text-white">
                        <div className="card-body">
                          <h6>Total Achats</h6>
                          <h4>{supplierStats.total_achats || 0}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-success text-white">
                        <div className="card-body">
                          <h6>Total Dépensé</h6>
                          <h4>
                            {formatCurrency(supplierStats.total_depense || 0)}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-warning text-white">
                        <div className="card-body">
                          <h6>Total Réglé</h6>
                          <h4>
                            {formatCurrency(supplierStats.total_regle || 0)}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-danger text-white">
                        <div className="card-body">
                          <h6>Solde Actuel</h6>
                          <h4>
                            {formatCurrency(supplierStats.solde_actuel || 0)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Tabs for Purchases and Payments */}
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "purchases" ? "active" : ""}`}
                      onClick={() => setActiveTab("purchases")}
                      // style={{
                      //   background: "none",
                      //   border: "none",
                      //   cursor: "pointer",
                      // }}
                    >
                      Achats ({supplierPurchases.length})
                    </button>
                  </li>
                </ul>

                {/* Purchases Tab */}
                {activeTab === "purchases" && (
                  <div>
                    {supplierPurchases.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th>Date</th>
                              <th>N° Facture</th>
                              <th>Total TTC</th>
                              <th>Réglé</th>
                              <th>Reste</th>
                              <th>Statut</th>
                            </tr>
                          </thead>
                          <tbody>
                            {supplierPurchases.map((purchase) => (
                              <tr key={purchase.id}>
                                <td>{formatdate(purchase.date_achat)}</td>
                                <td>{purchase.numero_facture}</td>
                                <td className="font-weight-bold">
                                  {formatCurrency(purchase.total_ttc)}
                                </td>
                                <td className="text-success">
                                  {formatCurrency(purchase.montant_regle || 0)}
                                </td>
                                <td
                                  className={
                                    purchase.solde_restant > 0
                                      ? "text-danger"
                                      : "text-success"
                                  }
                                >
                                  {formatCurrency(purchase.solde_restant || 0)}
                                </td>
                                <td>
                                  {purchase.valide ? (
                                    <span className="badge badge-success">
                                      Validé
                                    </span>
                                  ) : (
                                    <span className="badge badge-warning">
                                      En attente
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot className="table-info">
                            <tr>
                              <th colSpan="2">Totaux</th>
                              <th>
                                {formatCurrency(
                                  supplierPurchases.reduce(
                                    (sum, p) => sum + p.total_ttc,
                                    0,
                                  ),
                                )}
                              </th>
                              <th>
                                {formatCurrency(
                                  supplierPurchases.reduce(
                                    (sum, p) => sum + (p.montant_regle || 0),
                                    0,
                                  ),
                                )}
                              </th>
                              <th colSpan="2">
                                {formatCurrency(
                                  supplierPurchases.reduce(
                                    (sum, p) => sum + (p.solde_restant || 0),
                                    0,
                                  ),
                                )}
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    ) : (
                      <p className="text-center py-3">Aucun achat trouvé</p>
                    )}
                  </div>
                )}

                {/* Payments Tab */}
                {activeTab === "payments" && (
                  <div>
                    {supplierPayments.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th>Code</th>
                              <th>Date</th>
                              <th>N° Facture</th>
                              <th>Mode</th>
                              <th>Montant</th>
                            </tr>
                          </thead>
                          <tbody>
                            {supplierPayments.map((payment) => (
                              <tr key={payment.id}>
                                <td>{payment.code || "-"}</td>
                                <td>{formatdate(payment.date_paiement)}</td>
                                <td>{payment.numero_facture || "-"}</td>
                                <td>
                                  {payment.mode_paiement === "espece" &&
                                    "Espèces"}
                                  {payment.mode_paiement === "cheque" &&
                                    "Chèque"}
                                  {payment.mode_paiement === "virement" &&
                                    "Virement"}
                                  {payment.mode_paiement === "carte" && "Carte"}
                                </td>
                                <td className="text-success font-weight-bold">
                                  {formatCurrency(payment.montant)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot className="table-info">
                            <tr>
                              <th colSpan="4">Total</th>
                              <th>
                                {formatCurrency(
                                  supplierPayments.reduce(
                                    (sum, p) => sum + p.montant,
                                    0,
                                  ),
                                )}
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    ) : (
                      <p className="text-center py-3">Aucun paiement trouvé</p>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDetailsModal(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Supplier Modal */}
      <AddFournisseurModal
        isOpen={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setEditingFournisseur(null);
        }}
        onSuccess={() => {
          loadSuppliers(); // Refresh the list
        }}
        fournisseurId={editingFournisseur}
      />
      {showHistoriqueModal && historiqueSupplier && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fa fa-history mr-2"></i>
                  Historique — {historiqueSupplier.nom}
                  <span
                    className={`ml-3 ${historiqueSupplier.solde_actuel > 0 ? "text-danger" : "text-success"}`}
                  >
                    ({formatCurrency(historiqueSupplier.solde_actuel || 0)})
                  </span>
                </h5>
                <button
                  className="close"
                  onClick={() => setShowHistoriqueModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {historiqueLoading ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                    />
                    <p className="mt-2">Chargement...</p>
                  </div>
                ) : historiqueEvents.length === 0 ? (
                  <p className="text-center py-3 text-muted">
                    Aucun événement trouvé
                  </p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                      <thead className="thead-light">
                        <tr>
                          <th>Date</th>
                          <th>Type</th>
                          <th>N° Facture / Code</th>
                          <th>Détails</th>
                          <th>Montant</th>
                        </tr>
                      </thead>
                      <tbody>
                        {historiqueEvents.map((event, idx) => (
                          <tr
                            key={idx}
                            className={
                              event.type === "paiement" ? "table-success" : ""
                            }
                          >
                            <td>{formatDateAndTime(event.date)}</td>
                            <td>
                              {event.type === "achat" ? (
                                <span className="badge badge-danger">
                                  Achat
                                </span>
                              ) : (
                                <span className="badge badge-success">
                                  Paiement
                                </span>
                              )}
                            </td>
                            <td>{event.numero_facture || event.code || "-"}</td>
                            <td>
                              {event.type === "achat" ? (
                                <>
                                  Réglé:{" "}
                                  {formatCurrency(event.montant_regle || 0)}
                                  {" · "}
                                  Reste:{" "}
                                  <span
                                    className={
                                      event.solde_restant > 0
                                        ? "text-danger"
                                        : "text-success"
                                    }
                                  >
                                    {formatCurrency(event.solde_restant || 0)}
                                  </span>
                                </>
                              ) : (
                                <>
                                  {event.mode_paiement === "espece" &&
                                    "Espèces"}
                                  {event.mode_paiement === "cheque" && "Chèque"}
                                  {event.mode_paiement === "virement" &&
                                    "Virement"}
                                  {event.mode_paiement === "carte" && "Carte"}
                                </>
                              )}
                            </td>
                            <td
                              className={`font-weight-bold ${event.type === "achat" ? "text-danger" : "text-success"}`}
                            >
                              {event.type === "achat"
                                ? `+ ${formatCurrency(event.total_ttc)}`
                                : `- ${formatCurrency(event.montant)}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowHistoriqueModal(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FournisseurList;
